import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "apInputMask__inner" }
const _hoisted_2 = {
  key: 0,
  class: "apInputMask__label"
}
const _hoisted_3 = ["value", "placeholder", "disabled"]
const _hoisted_4 = {
  key: 1,
  class: "apInputMask__hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_wrapper = _resolveComponent("icon-wrapper")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['apInputMask', {'apInputMask--error': _ctx.hasErrorText}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(['apInputMask__field', {'apInputMask__field--border': _ctx.border}])
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "apInputMask__input",
          value: _ctx.modelValue,
          placeholder: _ctx.placeholder,
          disabled: _ctx.disabled,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
        }, null, 40, _hoisted_3), [
          [_directive_mask, _ctx.composeMask]
        ]),
        (_ctx.currentIcon)
          ? (_openBlock(), _createBlock(_component_icon_wrapper, {
              key: 0,
              "icon-name": _ctx.currentIcon
            }, null, 8, ["icon-name"]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.hintOrError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.hintOrError), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}